import React from 'react'
import PropTypes from 'prop-types'
import css from './patientCard.css'

const PatientAddress = ({ patient }) => {
  const street = patient.street_address || 'n/a'
  const city = patient.city || 'n/a'
  const state = patient.state || 'n/a'
  const zip = patient.zip || 'n/a'

  return (
    <div className={css.contactItem}>
      <span key="label" className={css.label}>Address</span>
      <span key="value" className={css.value}>{street}<br />{`${city}, ${state} ${zip}`}</span>
    </div>
  )
}

export default PatientAddress



// WEBPACK FOOTER //
// ./src/components/PatientPage/PatientCard/Address.js